import { forwardRef, useImperativeHandle, useState } from "react";
import { useHistory } from "react-router";
import Modal from "components/misc/Modal-V2";
import { INFO } from "components/misc/Modal-V2/constants";

const ReceiptErrorModal = ({ policyNumber, amount, currency, customer, paymentType }, ref) => {
    const [modalState, setModalState] = useState(false);
    const history = useHistory();

    useImperativeHandle(ref, () => ({
        openModal: () => setModalState(true),
        closeModal: () => setModalState(false),
        toggleModal: () => setModalState(!modalState)
    }));

    const referenceNumber = new Date().getDay() + "" + new Date().getUTCMonth() + "" + new Date().getFullYear() + "" + new Date().getMilliseconds() + "_"
        + policyNumber;

    const orderDate = new Date().toISOString().split("T")[0];

    const handleOk = () => {
        history.push("/confirmation");
        setModalState(false);
    };

    return (
        <Modal
            modalType={INFO}
            showModal={modalState}
            title="Payment Successful"
            primaryLabel="OK"
            primaryCallback={handleOk}
            closeModal={() => setModalState(false)}
        >
            <div className="modal-message" style={{ marginBottom: "20px" }}>
                Your payment has been successfully processed. However, your payment receipt was not generated. Please click 'OK' to continue.<br /> <br /> Please contact us at 876-978-3690-9
                with the payment details below.
            </div>
            <div className="modal-payment-details-container">
                <table>
                    <tr>
                        <td className="cell-title">Policy Number</td>
                        <td className="cell-value">{policyNumber}</td>
                    </tr>
                    <tr>
                        <td className="cell-title">Payment Type</td>
                        <td className="cell-value">{paymentType}</td>
                    </tr>
                    <tr>
                        <td className="cell-title">
                            Billing Name
                        </td>
                        <td className="cell-value">
                            {customer.firstName} {customer.lastName}
                        </td>
                    </tr>
                    <tr>
                        <td className="cell-title">
                            Billing Address
                        </td>
                        <td className="cell-value">
                            {customer.address}
                        </td>
                    </tr>
                    <tr>
                        <td className="cell-title">
                            Order Date
                        </td>
                        <td className="cell-value">
                            {orderDate}
                        </td>
                    </tr>
                    <tr>
                        <td className="cell-title">
                            Order Amount
                        </td>
                        <td className="cell-value">
                            {currency} {`$${amount}`}
                        </td>
                    </tr>
                    <tr>
                        <td className="cell-title">
                            Reference Number
                        </td>
                        <td className="cell-value">
                            {referenceNumber}
                        </td>
                    </tr>
                </table>
            </div>
        </Modal>
    )
}


export default forwardRef(ReceiptErrorModal);